import React, { useState } from 'react';
import '@rainbow-me/rainbowkit/styles.css';
import { RainbowKitProvider, connectorsForWallets, lightTheme } from '@rainbow-me/rainbowkit';
import { 
  trustWallet, bitgetWallet, okxWallet, metaMaskWallet, 
  injectedWallet, walletConnectWallet, rabbyWallet, 
  coinbaseWallet, binanceWallet 
} from '@rainbow-me/rainbowkit/wallets';
import { WagmiProvider, createConfig, http } from 'wagmi';
import { bsc } from 'wagmi/chains';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ClaimPage from './ClaimPage';
import SwapPage from './SwapPage';

// 5. Konfigurasi RPC Kustom (Ankr)
const customBsc = {
  ...bsc,
  rpcUrls: {
    default: { http: ['https://rpc.ankr.com/bsc/9eac904ebaa1333306011e829641a4c8f0da94785c711097ba7de2b744ccbce0'] }, // Ganti URL ini jika Anda punya endpoint Ankr berbayar/khusus
    public: { http: ['https://rpc.ankr.com/bsc/9eac904ebaa1333306011e829641a4c8f0da94785c711097ba7de2b744ccbce0'] },
  },
};

// 11. Urutan Wallet Custom Sesuai Instruksi
const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [
        trustWallet, bitgetWallet, okxWallet, metaMaskWallet, 
        injectedWallet, walletConnectWallet, rabbyWallet, 
        coinbaseWallet, binanceWallet
      ],
    },
  ],
  { appName: 'PRL App', projectId: '374c230611a3deb81bab39e386e46705' }
);

const config = createConfig({
  connectors,
  chains: [customBsc],
  transports: { [customBsc.id]: http() },
});

const queryClient = new QueryClient();

function App() {
  const [currentPage, setCurrentPage] = useState('claim');

  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider theme={lightTheme({ accentColor: '#6b7280' })}>
          {currentPage === 'claim' ? (
            <ClaimPage onGoToSwap={() => setCurrentPage('swap')} />
          ) : (
            <SwapPage onGoToClaim={() => setCurrentPage('claim')} />
          )}
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;